import { useSignUpCopyright } from 'builder/components/SignUpCopyright/SignUpCopyright'
import { Wrapper } from './styles'

export const SignUpCopyright = () => {
  const markup = useSignUpCopyright()

  return <Wrapper dangerouslySetInnerHTML={{ __html: markup }} />
}
